import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMentorRolesService } from '../services/roleService';

// async thunk
export const fetchMentorRoles = createAsyncThunk(
  'training/fetchMentorRoles',
  async () => {
    const response = await getMentorRolesService();
    return response.data;
  }
);

// slice
const trainingSlice = createSlice({
  name: 'training',
  initialState: {
    mentees: {},
    trainingTasks: {},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMentorRoles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMentorRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        Object.assign(state, action.payload);
      })
      .addCase(fetchMentorRoles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default trainingSlice.reducer;
export const trainingActions = trainingSlice.actions;
export const trainingSelectors = {
  selectMentees: (state) => state.training.mentees,
  selectTrainingTasks: (state) => state.training.trainingTasks,
  selectStatus: (state) => state.training.status,
  selectError: (state) => state.training.error,
};

// Backward compatibility: alias for existing imports
export { fetchMentorRoles as getMentorRoles };